/* eslint-disable max-len */
import {
  merge, pathOr, find, propEq, compose
} from 'ramda';

import Utils from 'src/utils';
import {
  LOAD_CONFIGURATION_FAIL,
  LOAD_CONFIGURATION_REQUEST,
  LOAD_CONFIGURATION_SUCCESS,
  PUT_CONFIGURATION_FAIL,
  PUT_CONFIGURATION_REQUEST,
  PUT_CONFIGURATION_SUCCESS,
  LOAD_CONFIGURATION_LUNCH_REQUEST,
  LOAD_CONFIGURATION_LUNCH_SUCCESS,
  LOAD_CONFIGURATION_LUNCH_FAIL,
  PUT_CONFIGURATION_LUNCH_REQUEST,
  PUT_CONFIGURATION_LUNCH_SUCCESS,
  PUT_CONFIGURATION_LUNCH_FAIL,
  LOAD_CONFIGURATION_BREAK_REQUEST,
  LOAD_CONFIGURATION_BREAK_SUCCESS,
  LOAD_CONFIGURATION_BREAK_FAIL,
  PUT_CONFIGURATION_BREAK_REQUEST,
  PUT_CONFIGURATION_BREAK_SUCCESS,
  PUT_CONFIGURATION_BREAK_FAIL,
  LOAD_CONFIGURATION_TIME_RATE_REQUEST,
  LOAD_CONFIGURATION_TIME_RATE_SUCCESS,
  LOAD_CONFIGURATION_TIME_RATE_FAIL,
  PUT_CONFIGURATION_TIME_RATE_REQUEST,
  PUT_CONFIGURATION_TIME_RATE_SUCCESS,
  PUT_CONFIGURATION_TIME_RATE_FAIL,
  LOAD_CONFIGURATION_GENERAL_REQUEST,
  LOAD_CONFIGURATION_GENERAL_SUCCESS,
  LOAD_CONFIGURATION_GENERAL_FAIL,
  PUT_CONFIGURATION_GENERAL_REQUEST,
  PUT_CONFIGURATION_GENERAL_SUCCESS,
  PUT_CONFIGURATION_GENERAL_FAIL,
  LOAD_CONFIGURATION_MERIT_REQUEST,
  LOAD_CONFIGURATION_MERIT_SUCCESS,
  LOAD_CONFIGURATION_MERIT_FAIL,
  PUT_CONFIGURATION_MERIT_REQUEST,
  PUT_CONFIGURATION_MERIT_SUCCESS,
  PUT_CONFIGURATION_MERIT_FAIL,
  LOAD_CONFIGURATION_DIRECTO_REQUEST,
  LOAD_CONFIGURATION_DIRECTO_SUCCESS,
  LOAD_CONFIGURATION_DIRECTO_FAIL,
  PUT_CONFIGURATION_DIRECTO_REQUEST,
  PUT_CONFIGURATION_DIRECTO_SUCCESS,
  PUT_CONFIGURATION_DIRECTO_FAIL,
  LOAD_CONFIGURATION_PERSONA_REQUEST,
  LOAD_CONFIGURATION_PERSONA_SUCCESS,
  LOAD_CONFIGURATION_PERSONA_FAIL,
  PUT_CONFIGURATION_PERSONA_REQUEST,
  PUT_CONFIGURATION_PERSONA_SUCCESS,
  PUT_CONFIGURATION_PERSONA_FAIL,
  LOAD_WORK_TIME_CALCULATION_TYPES_REQUEST,
  LOAD_WORK_TIME_CALCULATION_TYPES_SUCCESS,
  LOAD_WORK_TIME_CALCULATION_TYPES_FAIL,
  LOAD_CONFIGURATION_CONFIRMATION_ACTIONS_REQUEST,
  LOAD_CONFIGURATION_CONFIRMATION_ACTIONS_SUCCESS,
  LOAD_CONFIGURATION_CONFIRMATION_ACTIONS_FAIL,
  PUT_CONFIGURATION_CONFIRMATION_ACTIONS_REQUEST,
  PUT_CONFIGURATION_CONFIRMATION_ACTIONS_SUCCESS,
  PUT_CONFIGURATION_CONFIRMATION_ACTIONS_FAIL,
  LOAD_CONFIGURATION_AXAPTA_REQUEST,
  LOAD_CONFIGURATION_AXAPTA_SUCCESS,
  LOAD_CONFIGURATION_AXAPTA_FAIL,
  PUT_CONFIGURATION_AXAPTA_REQUEST,
  PUT_CONFIGURATION_AXAPTA_SUCCESS,
  PUT_CONFIGURATION_AXAPTA_FAIL,
  LOAD_CONFIGURATIONS_BY_KEYWORD_REQUEST, LOAD_CONFIGURATIONS_BY_KEYWORD_SUCCESS, LOAD_CONFIGURATIONS_BY_KEYWORD_FAIL,
  PUT_CONFIGURATIONS_BY_KEYWORD_REQUEST, PUT_CONFIGURATIONS_BY_KEYWORD_SUCCESS, PUT_CONFIGURATIONS_BY_KEYWORD_FAIL
} from 'src/store/actions/configurationActions';

const initialState = {
  data: {},
  lunch: {},
  breaks: {},
  timeRate: {},
  general: {},
  workTimeCalculationTypes: [],
  merit: null,
  directo: null,
  persona: null,
  axapta: null,
  confirmationActions: null,
  fetching: true,
  fetchingGeneral: false,
  fetchingLunch: false,
  fetchingBreak: false,
  fetchingConfigurationConfirmation: false,
  errors: [],
  initialized: false,
  byKeywords: [],
  byKeywordsFetching: false
};

export const selectConfigurations = pathOr({}, ['configurations', 'data']);

export const selectModulesConfiguration = compose(
  pathOr([], ['Modules']),
  selectConfigurations
);

export const selectModuleConfiguration = (Type) => compose(
  pathOr({}, ['Configuration']),
  find(propEq('Type', Type)),
  selectModulesConfiguration
);

export const selectEmployeesConfiguration = compose(
  pathOr({}, ['Employees']),
  selectModuleConfiguration('General')
);

const configurationsReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_CONFIGURATION_REQUEST:
    case PUT_CONFIGURATION_REQUEST:
    case PUT_CONFIGURATION_LUNCH_REQUEST:
    case PUT_CONFIGURATION_BREAK_REQUEST:
    case LOAD_CONFIGURATION_TIME_RATE_REQUEST:
    case PUT_CONFIGURATION_TIME_RATE_REQUEST:
    case PUT_CONFIGURATION_GENERAL_REQUEST:
    case LOAD_CONFIGURATION_MERIT_REQUEST:
    case PUT_CONFIGURATION_MERIT_REQUEST:
    case LOAD_CONFIGURATION_DIRECTO_REQUEST:
    case PUT_CONFIGURATION_DIRECTO_REQUEST:
    case LOAD_WORK_TIME_CALCULATION_TYPES_REQUEST:
    case PUT_CONFIGURATION_CONFIRMATION_ACTIONS_REQUEST:
    case LOAD_CONFIGURATION_AXAPTA_REQUEST:
    case PUT_CONFIGURATION_AXAPTA_REQUEST:
    case LOAD_CONFIGURATION_PERSONA_REQUEST:
    case PUT_CONFIGURATION_PERSONA_REQUEST:
      return merge(state, { fetching: true });
    case LOAD_CONFIGURATION_GENERAL_REQUEST:
      return merge(state, { fetching: true, fetchingGeneral: true });
    case LOAD_CONFIGURATION_LUNCH_REQUEST:
      return merge(state, { fetching: true, fetchingLunch: true });
    case LOAD_CONFIGURATION_BREAK_REQUEST:
      return merge(state, { fetching: true, fetchingBreak: true });
    case LOAD_CONFIGURATION_SUCCESS:
      return merge(state, { data: action.configurations, fetching: false, initialized: true });
    case PUT_CONFIGURATION_SUCCESS:
      return merge(state, { data: action.configurations, fetching: false });
    case LOAD_CONFIGURATION_LUNCH_SUCCESS:
      return merge(state, {
        lunch: action.configurations, fetchingLunch: false, fetching: false, initialized: true
      });
    case PUT_CONFIGURATION_LUNCH_SUCCESS:
      return merge(state, { lunch: action.configurations, fetching: false });
    case LOAD_CONFIGURATION_BREAK_SUCCESS:
      return merge(state, {
        breaks: action.configurations, fetchingBreak: false, fetching: false, initialized: true
      });
    case PUT_CONFIGURATION_BREAK_SUCCESS:
      return merge(state, { breaks: action.configurations, fetching: false });
    case LOAD_CONFIGURATION_TIME_RATE_SUCCESS:
      return merge(state, { timeRate: action.configurations, fetching: false, initialized: true });
    case PUT_CONFIGURATION_TIME_RATE_SUCCESS:
      return merge(state, { timeRate: action.configurations, fetching: false });
    case LOAD_CONFIGURATION_GENERAL_SUCCESS:
      return merge(state, {
        general: action.configurations, fetchingGeneral: false, fetching: false, initialized: true
      });
    case PUT_CONFIGURATION_GENERAL_SUCCESS:
      return merge(state, { general: action.configurations, fetching: false });
    case LOAD_CONFIGURATION_MERIT_SUCCESS:
      return merge(state, { merit: action.configurations, fetching: false, initialized: true });
    case PUT_CONFIGURATION_MERIT_SUCCESS:
      return merge(state, { merit: action.configurations, fetching: false });
    case LOAD_CONFIGURATION_DIRECTO_SUCCESS:
      return merge(state, { directo: action.configurations, fetching: false, initialized: true });
    case PUT_CONFIGURATION_DIRECTO_SUCCESS:
      return merge(state, { directo: action.configurations, fetching: false });
    case LOAD_CONFIGURATION_CONFIRMATION_ACTIONS_REQUEST:
      return merge(state, { fetchingConfigurationConfirmation: true, fetching: true });
    case LOAD_CONFIGURATION_CONFIRMATION_ACTIONS_SUCCESS:
      return merge(state, {
        confirmationActions: action.configurations, fetching: false, initialized: true, fetchingConfigurationConfirmation: false
      });
    case LOAD_CONFIGURATION_CONFIRMATION_ACTIONS_FAIL:
      return merge(state, { fetchingConfigurationConfirmation: false, fetching: false });
    case PUT_CONFIGURATION_CONFIRMATION_ACTIONS_SUCCESS:
      return merge(state, { confirmationActions: action.configurations, fetching: false });
    case LOAD_WORK_TIME_CALCULATION_TYPES_SUCCESS:
      return merge(state, { workTimeCalculationTypes: action.types, fetching: false });
    case LOAD_CONFIGURATION_AXAPTA_SUCCESS:
      return merge(state, { axapta: action.configurations, fetching: false, initialized: true });
    case PUT_CONFIGURATION_AXAPTA_SUCCESS:
      return merge(state, { axapta: action.configurations, fetching: false });
    case LOAD_CONFIGURATION_PERSONA_SUCCESS:
      return merge(state, { persona: action.configurations, fetching: false, initialized: true });
    case PUT_CONFIGURATION_PERSONA_SUCCESS:
      return merge(state, { persona: action.configurations, fetching: false });
    case LOAD_CONFIGURATION_FAIL:
    case PUT_CONFIGURATION_FAIL:
    case PUT_CONFIGURATION_LUNCH_FAIL:
    case PUT_CONFIGURATION_BREAK_FAIL:
    case LOAD_CONFIGURATION_TIME_RATE_FAIL:
    case PUT_CONFIGURATION_TIME_RATE_FAIL:
    case PUT_CONFIGURATION_GENERAL_FAIL:
    case LOAD_CONFIGURATION_MERIT_FAIL:
    case PUT_CONFIGURATION_MERIT_FAIL:
    case LOAD_CONFIGURATION_DIRECTO_FAIL:
    case PUT_CONFIGURATION_DIRECTO_FAIL:
    case LOAD_WORK_TIME_CALCULATION_TYPES_FAIL:
    case PUT_CONFIGURATION_CONFIRMATION_ACTIONS_FAIL:
    case LOAD_CONFIGURATION_AXAPTA_FAIL:
    case PUT_CONFIGURATION_AXAPTA_FAIL:
    case LOAD_CONFIGURATION_PERSONA_FAIL:
    case PUT_CONFIGURATION_PERSONA_FAIL:
      return merge(state, { errors: action.error, fetching: false });
    case LOAD_CONFIGURATION_GENERAL_FAIL:
      return merge(state, { errors: action.error, fetchingGeneral: false, fetching: false });
    case LOAD_CONFIGURATION_LUNCH_FAIL:
      return merge(state, { errors: action.error, fetchingLunch: false, fetching: false });
    case LOAD_CONFIGURATION_BREAK_FAIL:
      return merge(state, { errors: action.error, fetchingBreak: false, fetching: false });
    case LOAD_CONFIGURATIONS_BY_KEYWORD_REQUEST:
      return merge(state, { byKeywordsFetching: true });
    case LOAD_CONFIGURATIONS_BY_KEYWORD_SUCCESS:
      return merge(state, {
        byKeywords: action.configurations,
        byKeywordsFetching: false
      });
    case LOAD_CONFIGURATIONS_BY_KEYWORD_FAIL:
      return merge(state, { byKeywordsFetching: false });
    case PUT_CONFIGURATIONS_BY_KEYWORD_REQUEST:
      return merge(state, { fetching: true });
    case PUT_CONFIGURATIONS_BY_KEYWORD_SUCCESS:
      return merge(state, {
        byKeywords: Utils.arrays.mergeWithNestedObjectsReplace(state.byKeywords, action.configurations, 'Keyword'),
        byKeywordsFetching: false
      });
    case PUT_CONFIGURATIONS_BY_KEYWORD_FAIL:
      return merge(state, { fetching: false });
    default:
      return state;
  }
};

export default configurationsReducer;
